// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"488":"6882cb61","490":"ec3b2474","496":"0cec5d60","764":"c96cdb0a","875":"67b91cab","911":"aceb7da8"}[chunkId] + ".chunk.css";
};